import styled from 'styled-components'
import Flex from 'components/Flex'
import { COLORS } from 'theme'
import Drawer from 'components/Drawer'

export const StyledDrawer = styled(Drawer)`
  .ant-drawer-body {
    &::-webkit-scrollbar {
      display: none;
    }
  }
`
export const SectionWrapper = styled(Flex)`
  justify-content: flex-end;
  border-top: 2px solid ${COLORS.GREY_T_90};
  padding-top: 0.6rem;
  &::-webkit-scrollbar {
    display: '';
  }
`
export const LeftSection = styled.div`
  width: 35%;
  height: 100%;
`
export const RightSection = styled.div`
  width: 65%;
  height: 70vh;
  padding-left: 1rem;
  border-left: 1px solid ${COLORS.GREY_T_90};
`
export const DriveWrapper = styled.div`
  border: 2px solid ${COLORS.GREY_T_90};
  padding: 0.6rem 1rem;
  border-radius: 8px;
  margin-bottom: 0.7rem;
`
export const InfoSection = styled(Flex)`
  gap: 5px;
  margin-left: 10px;
  flex-direction: column;
  max-width: 480px;
`
export const Title = styled.div`
  font-weight: 500;
  line-height: 1.312rem;
  font-size: 15px;
  margin-bottom: 0.7rem;
`
export const HighlitedTag = styled.span`
  font-weight: 600;
  font-size: 1rem;
  line-height: 1.312rem;
  text-transform: capitalize;
`
